import React, { useState } from 'react';
import AreaCard from '../moduleComponents/AreaCard';
import AreaRecordsDrawer from '../moduleComponents/AreaRecordsDrawer';
import ModalRecordForm from '../tab_records/ModalRecordForm';
import SpinnerLoad from '../moduleComponents/SpinnerLoad';

// Summary — Areas sub-tab (L1). Visual grid of every area, one tap away from
// its recent records (bottom drawer), one more tap away from the full record
// (traditional modal). Tiles like the ecosystem home grid; icons via areaIcons.
const TabHealthSummaryAreas = ({
  records = [],
  areas = [],
  professionals = [],
  isLoading = false,
}) => {
  const [selectedArea, setSelectedArea] = useState(null);
  /** undefined = closed; object = viewing existing record */
  const [recordModal, setRecordModal] = useState(undefined);

  const recordsForSelectedArea = selectedArea
    ? records.filter((r) => r.area === selectedArea)
    : [];

  const handleRecordClick = (record) => {
    setRecordModal(record);
  };

  const handleRecordModalClose = () => {
    setRecordModal(undefined);
  };

  if (isLoading) {
    return (
      <div className="flex justify-center py-16">
        <SpinnerLoad />
      </div>
    );
  }

  return (
    <>
      {areas.length === 0 ? (
        <div className="bg-white p-6 rounded-2xl shadow">
          <p className="text-gray-500 text-sm">No areas yet — they show up here once you have records.</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 w-full">
          {areas.map((area) => (
            <AreaCard key={area} area={area} onClick={() => setSelectedArea(area)} />
          ))}
        </div>
      )}

      <AreaRecordsDrawer
        open={selectedArea !== null}
        area={selectedArea}
        records={recordsForSelectedArea}
        onClose={() => setSelectedArea(null)}
        onRecordClick={handleRecordClick}
      />

      {recordModal !== undefined && (
        <ModalRecordForm
          record={recordModal}
          areas={areas}
          professionals={professionals}
          onClose={handleRecordModalClose}
          onSaved={handleRecordModalClose}
          onDeleted={handleRecordModalClose}
        />
      )}
    </>
  );
};

export default TabHealthSummaryAreas;
